import { Fragment, useContext, useEffect, useState } from "react";
import KrFormContext, { KrFormContextLandslideType, LandslideRockDeposits, LandslideRocks, LandslideRocksDepositAzimuths, LandslideTectonics, NavHeadingsKROEnum, KrLandslideFormTypes } from "../../../../contexts/krFormContext";
import SelectInput from "../../../../components/shared/selectInput/selectInput";
import { iconStyle, styleFormField, styleFormFieldHalf, styleFormFieldOnThree, stylizationVerticalAlign } from "../../../../components/shared/stylization";
import { GetOptions, prepareDataSingleForSelect } from "../../../../helpers/prepareForSelect";
import { FormFieldProps } from "../../../../components/formField/types/formFieldProps";
import FormField from "../../../../components/formField/formField";
import ButtonField from "../../../../components/buttonField/buttonField";
import { classNameBtn, iconPosition } from "../../../../components/shared/button/types/buttonProps";
import { ButtonFieldProps } from "../../../../components/buttonField/types/buttonFieldProps";
import { ReactComponent as addCircleIcon } from '../../../../icons/add_circle.svg';
import { ReactComponent as Delete } from "../../../../icons/delete.svg";
import { Option } from "../../../../components/shared/selectInput/types/selectInputProps";
import TableActions from "../../../../components/shared/table/tableActions/tableActions";
import { CellContext, createColumnHelper } from "@tanstack/react-table";
import { HeadersTable } from "../../../../helpers/featureTableConstruct";
import { TableProps } from "../../../../components/shared/table/types/tableProps";
import Table from "../../../../components/shared/table/table";
import ConfirmModal from "../../../../components/modalWindow/confirmModal";
import { createConfigValidation, validation } from "../../../../helpers/validation/validation";
import { FormSectionProps } from "./shared/types/formSectionProps";
import CollectiveLabelChip from "../../collectiveEditionView/components/collectiveLabelChip";
import CollectiveSelectField from "../../collectiveEditionView/collectiveField/collectiveSelectField";
import { CollectivePreviewKey } from "../../../../helpers/collective/preview";
import { subsoilTableList, tableRecord } from "../../../../helpers/form/subsoilHelper";
import { checkIfMarkedForCommentFilter, fireAddCommentBtnOnClickForRow, getAddCommentBtnDetails, getFieldRef, getFieldRefForRow, getItemRef, getKRDictFieldNameForRow, renderSectionCommentBtn } from "../../../../helpers/form";
import { KROFieldDict } from "../../shared/commentsSidebar/fieldDict";
import { PatternType } from "../../../../contexts/types/card";

type Azimuths = {
    AzimuthValue?: number | string,
    UpadValue?: number | string,
    idx?: number
}

const Subsoil = (props: FormSectionProps) => {
    const { krForm, setkrForm } = useContext(KrFormContext) as KrFormContextLandslideType;
    const isFormNotValid =  krForm.config?.isValid !== undefined ? !krForm.config?.isValid : false;
    var tectonicDict = GetOptions("RODZAJ_TEKTONIKI_SID", krForm.dictionaries, true);
    var tectonicUnitsDict = GetOptions("JEDNOSTKI_TEKTONICZNE", krForm.dictionaries);
    var rocksDict = GetOptions("SKALY_RODZAJ_SID", krForm.dictionaries);

    var stratigraficDict: Option[] | undefined = [];
    stratigraficDict = GetOptions("STRATYGRAFIA_OD_SID", krForm.dictionaries);

    var rocksZalegDict = GetOptions("RODZAJ_ZALEGANIA_SKALY_SID", krForm.dictionaries, true);
    var defaultAzimuth: Azimuths[] = [{
        AzimuthValue: "",
        UpadValue: "",
        idx: structuredClone(krForm.rockDeposits?.length)
    }]
    const [azimuths, setAzimuths] = useState<Azimuths[]>(defaultAzimuth);
    const [azimuthUpadVisible, setAzimuthUpadVisible] = useState<boolean>(false);
    var defaultRocks: LandslideRocks = {};
    const [rocks, setRocks] = useState<LandslideRocks>(defaultRocks);
    //var defaultRocksAzimuths: LandslideRocksDepositAzimuths = {}
    //const [rocksAzimuths, setRocksAzimuths] = useState<LandslideRocksDepositAzimuths>(defaultRocksAzimuths);
    var defaultRocksDeposits: LandslideRockDeposits = {}
    const [rocksDeposits, setRocksDeposits] = useState<LandslideRockDeposits>(defaultRocksDeposits);
    const [confirmation, setConfirmation] = useState<boolean>(false);
    const [developmentRow, setDevelopmentRow] = useState<any>(null);
    const [reload, setReload] = useState<boolean>(false);
    const [checkValidation, setCheckValidation] = useState<boolean>(false);
    const [checkAzimuthValidation, setCheckAzimuthValidation] = useState<boolean>(false);
    const [validateAzimuthReload, setValidateAzimuthReload] = useState<boolean>(false);
    const [tableError, setTableError] = useState<boolean>(false);
    const [tableErrorMsg, setTableErrorMsg] = useState<string>('');
    const [focusTable, setFocusTable] = useState<boolean>(false);

    const refocus = () => {
        setFocusTable(true);
    }

    // Validation
    useEffect(() => {
        if (krForm.config?.check && !krForm.config.isValid) {
            var errorMsg = krForm.config?.ValidationError!["rocks"]
            if (errorMsg !== '') {
                setTableError(true);
                setTableErrorMsg(errorMsg);
            }
        }  
        
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [krForm.config?.check])

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    var inputProps: FormFieldProps = {
        style: styleFormFieldOnThree,
        type: "text",
        configValidation: {
            required: true
        },
        validationError: isFormNotValid,
        disabled: !props.editMode,
    }

    const getFilteredRocksDict = () => {
        // If no REGION_NADRZEDNY don't modify dict
        if (!krForm.landslideAttributes?.regioN_NADRZEDNY) return rocksDict

        var filteredRocksDict = rocksDict;
        var polandDictSorted = rocksDict?.filter(item => item.anothers.REGION_NADRZEDNY === "cała Polska").sort((a: Option, b: Option) => a.name!.localeCompare(b.name!, 'pl'));

        // If Karpaty return Karpaty dict (sorted by stratografia chronology) + rest of Poland dict (sorted alphabetically)
        if (krForm.landslideAttributes?.regioN_NADRZEDNY.includes("Karpaty")) {
            var karpatyDict = rocksDict?.filter(item => item.anothers.REGION_NADRZEDNY === "Karpaty");
            var karpatyDictWithChrono = karpatyDict?.map(item => {
                var strat = stratigraficDict?.find(elem => elem.value === item.anothers.STRATYGRAFIA_OD_ID);
                item.anothers.chrono = strat?.anothers.CHRONOLOGIA;
                return item;
            })
            if (karpatyDictWithChrono) filteredRocksDict = karpatyDictWithChrono.sort((a, b) => a.anothers.chrono! - b.anothers.chrono!)?.concat(polandDictSorted ? polandDictSorted : []);
        }

        // If Sudety return Sudety dict (sorted by stratografia chronology and filtered by tectonic unit if selected) + rest of Poland dict (sorted alphabetically)
        else if (krForm.landslideAttributes?.regioN_NADRZEDNY.includes("Sudety")) {
            var sudetyDict = rocksDict?.filter(item => item.anothers.REGION_NADRZEDNY === "Sudety");           
            var sudetyDictFilteredByTectonics = sudetyDict;
            if (krForm.tectonicUnits && krForm.tectonicUnits?.length > 0) {
                var tectonicUnitsOptions = tectonicUnitsDict?.filter(item => krForm.tectonicUnits?.find(elem => elem.jednostkA_TEKTONICZNA_GID === item.anothers.GLOBALID));
                if (tectonicUnitsOptions?.every(tect => tect.anothers.UWAGI === "Sudety i blok przedsudecki")) sudetyDictFilteredByTectonics = sudetyDict?.filter(item => tectonicUnitsOptions?.find(elem => elem.anothers.ID === item.anothers.JEDNOSTKA_TEKTONICZNA_ID))
            }
            var sudetyDictWithChronoFilteredByTectonics = sudetyDictFilteredByTectonics?.map(item => {
                var strat = stratigraficDict?.find(elem => elem.value === item.anothers.STRATYGRAFIA_OD_ID);
                item.anothers.chrono = strat?.anothers.CHRONOLOGIA;
                return item;
            })
            if (sudetyDictWithChronoFilteredByTectonics) filteredRocksDict = sudetyDictWithChronoFilteredByTectonics.sort((a, b) => a.anothers.chrono! - b.anothers.chrono!)?.concat(polandDictSorted ? polandDictSorted : []);
        }

        // If different than Karpaty or Sudety, but not null, return rest of Poland dict (sorted alphabetically)
        else if (!krForm.landslideAttributes?.regioN_NADRZEDNY.includes("Karpaty") && !krForm.landslideAttributes?.regioN_NADRZEDNY.includes("Sudety")) filteredRocksDict = polandDictSorted;

        return filteredRocksDict;
    }

    const CheckValid = () => {
        setCheckValidation(true);
        if (rocksDeposits.rodzaJ_ZALEGANIA_SKALY_SID === undefined ||
            rocks.skalY_RODZAJ_SID === undefined ||
            rocks.stratygrafiA_OD_SID === undefined) {
            return false;
        }
        return true;
    }

    const CheckValidationAzimuths = () => {
        // eslint-disable-next-line array-callback-return
        var azimuthsCheck = azimuths.filter((option) => {
            if (option.AzimuthValue || option.UpadValue) {
                setCheckAzimuthValidation(true);
                return option.AzimuthValue === undefined || option.UpadValue === undefined
                || option.AzimuthValue === "" || option.UpadValue === "" || option.AzimuthValue as number < 0 || option.UpadValue as number < 1
                || option.AzimuthValue as number > 359 || option.UpadValue as number > 90;
            }
        })

        return (azimuthsCheck.length === 0 || (rocksDeposits.rodzaJ_ZALEGANIA_SKALY_SID === 1 || rocksDeposits.rodzaJ_ZALEGANIA_SKALY_SID === 7))
    }

    const enableAzimuthValidation = (azimuth: Azimuths) => {
        var azVal = azimuth.AzimuthValue != null && azimuth.AzimuthValue !== undefined && azimuth.AzimuthValue !== '';
        var upVal = azimuth.UpadValue != null && azimuth.UpadValue !== undefined && azimuth.UpadValue !== '';

        return (azVal || upVal) && checkAzimuthValidation;
    }

    useEffect(() => {
        setValidateAzimuthReload(!validateAzimuthReload);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [checkAzimuthValidation, azimuths])

    const setValueAzimuth = (value: any, idx: number) => {
        var azimuthsCopy = structuredClone(azimuths);
        azimuthsCopy[idx].AzimuthValue = value;
        setAzimuths(azimuthsCopy);
    }

    const setValueUpad = (value: any, idx: number) => {
        var azimuthsCopy = structuredClone(azimuths);
        azimuthsCopy[idx].UpadValue = value;
        setAzimuths(azimuthsCopy);
    }

    const addAzimuth = (event: any) => {
        var azimuth: Azimuths = {
            AzimuthValue: "",
            UpadValue: "",
            idx: structuredClone(krForm.rockDeposits?.length)
        }
        var azimuthsCopy = structuredClone(azimuths);
        azimuthsCopy.push(azimuth);
        if (azimuthsCopy.length < 6) {
            setAzimuths(azimuthsCopy);
        }
    }

    const checkForEmptyAzimuths = (rec: Azimuths) => {
        return (rec.UpadValue !== undefined && rec.UpadValue !== '') || (rec.AzimuthValue !== undefined && rec.AzimuthValue !== '')
    }

    const addToTable = (event: any) => {
        var form = structuredClone(krForm);
        if(form.rockDeposits == null || form.rockDeposits === undefined){
            form.rockDeposits = [];
        }
        if(form.rocksDepositAzimuths == null || form.rocksDepositAzimuths === undefined){
            form.rocksDepositAzimuths = [];
        }
        var newObject = structuredClone(rocks);
        var newObjectRockDeposit = structuredClone(rocksDeposits);
        var newObjectAzimuts = structuredClone(azimuths);

        var valid = CheckValid() && CheckValidationAzimuths();
        if (valid) {
            if (form && form.rocks) {
                var length: number = -1;
                length = structuredClone(form.rocks.length);
                if (length > -1) {
                    form.rocks.push(newObject);
                }
                newObjectRockDeposit.idx = structuredClone(form.rockDeposits?.length);
                form.rockDeposits?.push(newObjectRockDeposit);
                if (newObjectRockDeposit.rodzaJ_ZALEGANIA_SKALY_SID !== 1 && newObjectRockDeposit.rodzaJ_ZALEGANIA_SKALY_SID !== 7) {
                    for (var i = 0; i < newObjectAzimuts.length; i++) {
                        if (checkForEmptyAzimuths(newObjectAzimuts[i])) {
                            var azimuthes: LandslideRocksDepositAzimuths = {
                                //osuwiskO_GID: krForm.landslideAttributes?.globalid,
                                upad: newObjectAzimuts[i].UpadValue as number,
                                azymut: newObjectAzimuts[i].AzimuthValue as number,
                                idx: structuredClone(newObjectRockDeposit.idx)
                            }
                            form.rocksDepositAzimuths?.push(azimuthes);
                        }
                    }
                }
                form.rocks?.forEach((rock, index) => {
                    rock.kolejnosc = index + 1;
                })
                form.rockDeposits?.forEach((rock, index) => {
                    rock.kolejnosc = index + 1;
                })
                setTimeout(() => { 
                    setRocks(defaultRocks);
                    setRocksDeposits(defaultRocksDeposits);
                    setAzimuths(defaultAzimuth);
                    refreshValidation(form.rocks);
                    setkrForm(form);
                    setAzimuthUpadVisible(false);
                    setReload(!reload);
                    setCheckValidation(false);
                    setCheckAzimuthValidation(false);
                }, 150);
            }
        }
    }

    const refreshValidation = (values: LandslideRocks[] | undefined) => {
        const currValidation = createConfigValidation("rocks", false);
        const currValidationMsg = validation(currValidation, values);
        if (currValidationMsg) {
            setTableError(true);
            setTableErrorMsg(currValidationMsg);
        } else {
            setTableError(false);
            setTableErrorMsg('');
        }
    }

    const getBtnProps = (title: string, icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>, addTable?: boolean): ButtonFieldProps => {

        return {
            BtnProps: {
                onClick: (e: any) => { addTable ? addToTable(e) : addAzimuth(e) },
                style: {
                    width: '100%',
                },
                className: classNameBtn.Small
            },
            placeHolder: title,
            placeHolderStyle: stylizationVerticalAlign,
            additionalIcon: icon,
            iconPosition: iconPosition.Start,
            wrapperProps: {
                style: {
                    width: '32%',
                    paddingBottom: '5px',
                    textAlign: 'left',
                    alignItems: 'end',
                    display: 'flex'
                }
            }
        };
    }

    const deleteAzimuth = (event: any, idx: number) => {
        var azimuthsCopy = structuredClone(azimuths);
        azimuthsCopy.splice(idx, 1);
        azimuthsCopy.forEach((azimuth, idx) => {
            azimuth.idx = idx;
        })
        setAzimuths(azimuthsCopy);
        setCheckValidation(false);
    }

    const createAzimuths = (last: boolean, azimuth: Azimuths, idx: number) => {
        var objects: JSX.Element = <Fragment key={idx}>
            {last && idx !== 4 ? <ButtonField {...getBtnProps("Dodaj kolejny azymut i upad", addCircleIcon)}></ButtonField> : <div style={{
                width: '32%',
                alignItems: 'center',
                justifyContent: 'end',
                display: 'flex'
            }}><Delete {...PropsSVG} onClick={(event: any) => { deleteAzimuth(event, idx) }} /></div>}
            <FormField {...inputProps} type="text" onlyDigits={true} labelName="Azymut" setValue={(value) => { setValueAzimuth(value, idx) }} validationError={enableAzimuthValidation(azimuth)}
                value={structuredClone(azimuth.AzimuthValue)} disabled={false} configValidation={createConfigValidation("Azimuths")} reload={validateAzimuthReload}/>
            <FormField {...inputProps} type="text" onlyDigits={true} labelName="Upad" setValue={(value) => { setValueUpad(value, idx) }} validationError={enableAzimuthValidation(azimuth)}
                value={structuredClone(azimuth.UpadValue)} disabled={false} configValidation={createConfigValidation("Upad")} reload={validateAzimuthReload}/>
        </Fragment>
        return (objects);
    }

    const PropsSVG: React.SVGAttributes<SVGSVGElement> = {
        style: iconStyle,
        width: 24,
        height: 24,
        fill: '#999490'
    }

    const rocksDepositsAfterOnChange = (opt: Option[] | undefined | Option) => {
        var form = Object.assign({}, krForm);
        var rockDeposits = structuredClone(rocksDeposits);
        if (rockDeposits && (opt as Option[]).length > 0) {
            rockDeposits.rodzaJ_ZALEGANIA_SKALY_SID = (opt as Option[])[0].value as number;
            rockDeposits.osuwiskO_GID = krForm.landslideAttributes?.globalid;
            rockDeposits.idx = structuredClone(form.rockDeposits?.length);
            if ((opt as Option[])[0].name === "poziome" || (opt as Option[])[0].name === "brak możliwości obserwacji") {
                setAzimuthUpadVisible(false);
            }
            else {
                setAzimuthUpadVisible(true);
            }
        }
        else {
            if((opt as Option[]).length === 0){
                rockDeposits.rodzaJ_ZALEGANIA_SKALY_SID = undefined;
            }
            setAzimuthUpadVisible(false);
        }
        setRocksDeposits(rockDeposits);
    }

    const rocksAfterOnChange = (opt: Option[] | undefined | Option) => {
        var rock: LandslideRocks = rocks;
        rock.skalY_RODZAJ_SID = undefined;
        var Options = opt as Option[];
        if (Options) {
            Options.forEach((option) => {
                    if(option.anothers && option.anothers["STRATYGRAFIA_OD_ID"]){
                        rock.stratygrafiA_OD_SID = stratigraficDict?.find((optioned) => {
                            return optioned.value === option.anothers["STRATYGRAFIA_OD_ID"];
                        })?.value as number;
                    }
                    if(option.anothers && option.anothers["STRATYGRAFIA_DO_ID"]){ 
                        rock.stratygrafiA_DO_SID = stratigraficDict?.find((optioned) => {
                            return optioned.value === option.anothers["STRATYGRAFIA_DO_ID"];
                        })?.value as number;
                    }
                rock.skalY_RODZAJ_SID = option.value as number
                rock.osuwiskO_GID = krForm.landslideAttributes?.globalid;
            })
        }
        setRocks(rock);
        setReload(!reload);
    }

    const AgeAfterOnChange = (opt: Option[] | undefined | Option) => {
        var rock: LandslideRocks = rocks;
        rock.stratygrafiA_OD_SID = undefined;
        rock.stratygrafiA_DO_SID = undefined;
        var Options = opt as Option[];
        if (Options) {
            Options.forEach((option, idx) => {
                if (idx === 0) {
                    rock.stratygrafiA_OD_SID = option.value as number;
                }
                if (idx === 1) {
                    rock.stratygrafiA_DO_SID = option.value as number;
                }
            })
        }
        setRocks(rock);
    }

    const TectonicsAfterOnChange = (opt: Option[] | undefined) => {
        var form = Object.assign({}, krForm);
        var Options = opt as Option[];
        var landslideTectionics: LandslideTectonics[] = [];
        if (Options) {
            Options.forEach((option) => {
                landslideTectionics.push({
                    rodzaJ_TEKTONIKI_SID: option.value as number,
                    osuwiskO_GID: krForm.landslideAttributes?.globalid
                });
            })
        }
        form.tectonics = landslideTectionics;
        form.tectonics?.forEach((tect, index) => {
            tect.kolejnosc = index + 1;
        })
        setkrForm(form);
    }



    let headers = {
        rodzaj: props.version === 1 ? "Rodzaj utworów" : "Rodzaj skał/gruntów",
        wiek: props.version === 1 ? "Wiek utworów" : "Wiek skał/gruntów",
        zaleganie: "Zaleganie warstw"
    };

    const createTableList = () => {
        return subsoilTableList(krForm, rocksDict, stratigraficDict, rocksZalegDict);
    }

    const draggableRows = props.editMode;

    const cellAction = (properties: CellContext<any, unknown>) => {
        return (<TableActions
            row={properties.row}
            objectType={"elaborators"}
            deleteClickHandler={handleDeleteClick}
            draggableStyle={draggableRows}
            addCommentBtnVisible={!props.editMode}
            addCommentBtnClickHandler={handleAddCommentClick}
            addCommentBtnRef={getAddCommentBtnRef}
            checkIfMarkedForCommentFilter={checkIfRowMarkedForCommentFilter}
        />)
    }

    const checkIfRowMarkedForCommentFilter = (row: any) => {
        if (props.markedFieldForCommentFiltering) {
            return checkIfMarkedForCommentFilter(KROFieldDict.podl_podloze, row.id, props.markedFieldForCommentFiltering)
        }
    }

    const handleDeleteClick = (row: any) => {
        setDevelopmentRow(row);
        setConfirmation(true);
    }

    const handleAddCommentClick = (row: any) => {
        fireAddCommentBtnOnClickForRow(KROFieldDict.podl_podloze, row.id, 
            "Wiersz sekcji: Podłoże", 
            props.setNewCommentFieldDetails!);
    }

    const getAddCommentBtnRef = (node: any, row: any) => {
        getFieldRefForRow(node, KROFieldDict.podl_podloze, row.id, props.getMapForComment!);
    }

    const handleReorderRows = (data: tableRecord[]) => {
        var numberedNewData: LandslideRocks[] = [];
        var depositsList: LandslideRockDeposits[] = [];
        var azimuthsList: LandslideRocksDepositAzimuths[] = [];
        var rocksCopy = structuredClone(krForm.rocks);
        rocksCopy?.sort((a, b) => a.kolejnosc! - b.kolejnosc!);
        for(var i = 0; i<data.length; i++){
            // eslint-disable-next-line no-loop-func
            var itemObject = structuredClone(rocksCopy?.find((rock, idx) => {
                return idx === data[i].id
            }))
            if(itemObject) {
                itemObject.kolejnosc = i+1;
                // eslint-disable-next-line no-loop-func
                var deposits = structuredClone(krForm.rockDeposits?.filter((deposit) => {
                    return deposit.idx === data[i].id
                }));
                // eslint-disable-next-line no-loop-func
                deposits?.forEach((depo) =>{
                    depo.idx = i;
                })
                if(deposits){
                    depositsList = depositsList.concat(deposits);
                }
                // eslint-disable-next-line no-loop-func
                var azimuths = structuredClone(krForm.rocksDepositAzimuths?.filter((azimuth) => {
                    return azimuth.idx === data[i].id
                }))
                // eslint-disable-next-line no-loop-func
                azimuths?.forEach((azimu) => {
                    azimu.idx = i;
                })

                if(azimuths){
                    azimuthsList = azimuthsList.concat(azimuths);
                }
                numberedNewData.push(itemObject);
            }
        }
        var form: KrLandslideFormTypes = Object.assign({}, krForm);
        if (form !== null) {
            form.rocks = numberedNewData;
            form.rockDeposits = depositsList;
            form.rocksDepositAzimuths = azimuthsList;
        }
        setkrForm(form);
    }

    var tableProps: TableProps = {
        columnAliases: headers,
        columnHelper: createColumnHelper<HeadersTable>(),
        columnNames: Object.keys(headers),
        cellActions: cellAction,
        data: krForm.rocks ? createTableList() : [],
        loading: false,
        className: "table",
        draggableRows: draggableRows,
        tableError: props.collectiveEdition ? false: tableError,
        tableErrorMsg: tableErrorMsg,
        handleReorderRows: handleReorderRows,
        setCommentsFilter: (row: any) => { if (props.setCommentsFilter) props.setCommentsFilter(getKRDictFieldNameForRow(KROFieldDict.podl_podloze, row.id)); },
        checkIfMarkedForCommentFilter: (row: any) => { checkIfRowMarkedForCommentFilter(row) },
        narrowTableForCommentBtns: !props.editMode,
        refocus: focusTable,
        setRefocusTable: setFocusTable
    }

    const deleteSubsoil = (row: any) => {
        var form = structuredClone(krForm);
        if (form !== null && form.rocks) {
            var newAzimuths: LandslideRocksDepositAzimuths[] = [];
            var newDeposits: LandslideRockDeposits[] = [];
            var newRocks = form.rocks.filter((item: any, idx) => {
                return idx !== row.id
            })
            if (form.rocksDepositAzimuths) {
                var azimut: LandslideRocksDepositAzimuths[] = [];
                for (var j = 0; j < form.rocksDepositAzimuths.length; j++) {
                    var newAzimutCauseIn = Object.assign({}, form.rocksDepositAzimuths[j]);
                    azimut.push(newAzimutCauseIn);
                }
                newAzimuths = azimut.filter((item2) => {
                    return item2.idx !== row.id;
                })
                newAzimuths.forEach((azimut, idx) => {
                    if (azimut.idx && row.id < azimut.idx) {
                        azimut.idx = azimut.idx - 1;
                    }
                })
            }
            if (form.rockDeposits) {
                var deposit: LandslideRockDeposits[] = [];
                for (var k = 0; k < form.rockDeposits.length; k++) {
                    var newDepositsIn = Object.assign({}, form.rockDeposits[k]);
                    deposit.push(newDepositsIn);
                }
                newDeposits = deposit.filter((item2) => {
                    return item2.idx !== row.id;
                })
                newDeposits.forEach((deposit, idx) => {
                    deposit.idx = idx;
                })
            }
            newRocks.forEach((rock, index) => {
                rock.kolejnosc = index + 1;
            })
            newRocks.sort((a, b) => a.kolejnosc! - b.kolejnosc!);
            form.rocks = newRocks;
            form.rockDeposits = newDeposits;
            form.rocksDepositAzimuths = newAzimuths;
        }
        refreshValidation(form.rocks);
        setkrForm(form);
    }

    const confirm = () => {
        setConfirmation(false);
        deleteSubsoil(developmentRow);
    }

    const getQuestion = () => {
        return `Czy na pewno chcesz usunąć podłoże?`;
    }

    const cancel = () => {
        setConfirmation(false);
    }

    const getStratigraf = () => {
        var stratigraf: number[] = [];
        if (rocks.stratygrafiA_OD_SID !== undefined) {
            stratigraf.push(rocks.stratygrafiA_OD_SID as number);
        }
        if (rocks.stratygrafiA_DO_SID !== undefined) {
            stratigraf.push(rocks.stratygrafiA_DO_SID as number);
        }
        return stratigraf;
    }

    const reloadWiek = () => {
        return (<SelectInput style={props.collectiveEdition ? styleFormField : styleFormFieldHalf} label={props.version === 1 ? "Wiek utworów" : "Wiek skał/gruntów"}
            hasInputTags={true} options={stratigraficDict} onlySingleTag={false} onlyTwoTags={true} validationError={checkValidation} reload={reload}
            selectedOptions={prepareDataSingleForSelect(stratigraficDict, getStratigraf(), undefined)} onChange={AgeAfterOnChange}
            configValidation={createConfigValidation("onlyRequired")} optionsSliceOff={true} />)
    }
    const reloadRodzaj = () => {
        return (<SelectInput style={styleFormField} label={props.version === 1 ? "Rodzaj utworów" : "Rodzaj skał/gruntów"}
            hasInputTags={true} options={getFilteredRocksDict()} onlySingleTag={true} validationError={checkValidation}
            selectedOptions={prepareDataSingleForSelect(rocksDict, undefined, rocks.skalY_RODZAJ_SID)} reload={reload}
            onChange={rocksAfterOnChange} configValidation={createConfigValidation("onlyRequired")} optionsSliceOff={true} />)
    }

    const reloadZaleganie = () => {
        return (<SelectInput style={props.collectiveEdition ? styleFormField : styleFormFieldHalf} label="Zaleganie warstw"
            hasInputTags={true} options={rocksZalegDict} onlySingleTag={true} validationError={checkValidation} reload={reload}
            selectedOptions={prepareDataSingleForSelect(rocksZalegDict, undefined, rocksDeposits.rodzaJ_ZALEGANIA_SKALY_SID)}
            onChange={rocksDepositsAfterOnChange} configValidation={createConfigValidation("onlyRequired")}/>)
    }

    const reloadAzimuths = () => {
        if (props.collectiveEdition) {
            return (azimuthUpadVisible ? azimuths.map((azimuth, idx) => {
                if (idx === azimuths.length - 1) return <div className="collective-row" style={{alignItems: 'flex-end'}}>{createAzimuths(true, azimuth, idx)}</div>
                return <div className="collective-row" style={{alignItems: 'center'}}>{createAzimuths(false, azimuth, idx)}</div>
            }) : null);
        }

        return (azimuthUpadVisible ? azimuths.map((azimuth, idx) => {
            if (idx === azimuths.length - 1) return createAzimuths(true, azimuth, idx);
            return createAzimuths(false, azimuth, idx);
        }) : null)
    }

    const sortTectonics = () => {
        var data = (krForm as KrLandslideFormTypes).tectonics;
        if(data) data.sort((a, b) => a.kolejnosc! - b.kolejnosc!)
        return data;
    }

    if (props.collectiveEdition) {
        return (
            <>
                <h2 style={{ width: '100%' }}>5. Podłoże</h2>
                <div className='collective-block'>
                    <div className="collective-input">{reload ? reloadRodzaj() : reloadRodzaj()}<CollectiveLabelChip isAuto={true} /></div>
                    <div className="collective-row">
                        <div className="collective-input">{reload ? reloadWiek() : reloadWiek()}<CollectiveLabelChip isAuto={true} /></div>
                        <div className="collective-input">{reload ? reloadZaleganie() : reloadZaleganie()}<CollectiveLabelChip isAuto={false} /></div>
                    </div>
                    {reload ? reloadAzimuths() : <>{reloadAzimuths()}</>}
                    <div className="collective-right-btn">
                        <ButtonField {...getBtnProps("Dodaj wydzielenie", addCircleIcon, true)}></ButtonField>
                    </div>
                </div>
                <CollectiveSelectField top={false} value={(krForm as KrLandslideFormTypes).rocks} title={"Podłoże"}
                    forms={props.forms} keyName={CollectivePreviewKey.skaly} actions={props.actions} single={false}
                    dics={{"rocksDict": rocksDict, "stratigraficDict": stratigraficDict, "rocksZalegDict": rocksZalegDict}}
                    setActions={props.setActions} onDelete={props.onDelete} preventDelete={true} preventOverwrite={true}>
                    <div style={{width: '100%'}}><Table {...tableProps} /></div>
                </CollectiveSelectField>
                {confirmation &&
                    <ConfirmModal width={"660px"} height={"auto"}
                        confirmTitle={"Tak, usuń podłoże"}
                        onConfirm={confirm}
                        cancelTitle={"Anuluj"}
                        onCancel={cancel}
                        question={getQuestion()}
                        refocus={refocus}
                    />}
                <CollectiveSelectField top={true} value={(krForm as KrLandslideFormTypes).tectonics} isAuto={false} title={"Tektonika"}
                    forms={props.forms} keyName={CollectivePreviewKey.tectonics} actions={props.actions} single={false} dic={tectonicDict}
                    setActions={props.setActions} onDelete={props.onDelete}>
                    <SelectInput style={styleFormField} label="Tektonika"
                        hasInputTags={true} options={tectonicDict} onlySingleTag={false}
                        selectedOptions={prepareDataSingleForSelect(tectonicDict, sortTectonics()?.map((value) => {
                            return value.rodzaJ_TEKTONIKI_SID;
                        }), undefined)} onChange={TectonicsAfterOnChange} />
                </CollectiveSelectField>
            </>
        )
    }

    const getSectionHeading = () => {
        return props.version === PatternType.P2007 ? "5. Podłoże osuwiska" : "5. Podłoże";
    }

    return (
        <>
            <div ref={(node: any) => {getFieldRef(node, KROFieldDict.podl_sekcja, props.getMapForComment!)}} style={{ width: '100%' }}></div>
            <h2 ref={(node) => getItemRef(node, NavHeadingsKROEnum.Subsoil, props.getMapForNavScroll!)} style={{ width: '100%' }} 
                onClick={() => { if(props.setCommentsFilter) props.setCommentsFilter(KROFieldDict.podl_sekcja); }}>
                {getSectionHeading()}
            </h2>
            {!props.editMode && renderSectionCommentBtn(props.markedFieldForCommentFiltering === KROFieldDict.podl_sekcja, false, getSectionHeading(), props.setNewCommentFieldDetails!, KROFieldDict.podl_sekcja)}
            {props.editMode && 
                <>
                    {reload ? reloadRodzaj() : <>{reloadRodzaj()}</>}
                    {reload ? reloadWiek() : <>{reloadWiek()}</>}
                    {reload ? reloadZaleganie() : <>{reloadZaleganie()}</>}
                    {reload ? reloadAzimuths() : <> {reloadAzimuths()}</>}
                    <div style={styleFormFieldHalf}></div>
                    <ButtonField {...getBtnProps("Dodaj wydzielenie", addCircleIcon, true)}></ButtonField>
                </>
            }
            <Table {...tableProps} />
            {confirmation &&
                <ConfirmModal width={"660px"} height={"auto"}
                    confirmTitle={"Tak, usuń podłoże"}
                    onConfirm={confirm}
                    cancelTitle={"Anuluj"}
                    onCancel={cancel}
                    question={getQuestion()}
                    refocus={refocus}
                />}
            <SelectInput 
                style={styleFormField} 
                label="Tektonika"
                hasInputTags={true} 
                options={tectonicDict} 
                onlySingleTag={false} 
                validationError={isFormNotValid}
                selectedOptions={prepareDataSingleForSelect(tectonicDict, sortTectonics()?.map((value) => {
                    return value.rodzaJ_TEKTONIKI_SID;
                }), undefined)} 
                onChange={TectonicsAfterOnChange} configValidation={createConfigValidation("tectonics")}
                pristine={true}
                disabled={!props.editMode}
                addCommentBtn={getAddCommentBtnDetails(props.editMode!, KROFieldDict.podl_tektonika, "Tektonika", props.setNewCommentFieldDetails!)}
                selectRef={(node: any) => {getFieldRef(node, KROFieldDict.podl_tektonika, props.getMapForComment!)}} 
                setCommentsFilter={() => { if(props.setCommentsFilter) props.setCommentsFilter(KROFieldDict.podl_tektonika); }}
                isMarkedForCommentFilter={props.markedFieldForCommentFiltering === KROFieldDict.podl_tektonika}
                />
        </>
    )
}

export default Subsoil;